import { FC } from 'react';
import { AppBar, Button, Container, Toolbar, Typography, useTheme } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

export const AppBarBackLayout: FC = () => {
  const { palette } = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: palette.primary.dark }}>
        <Toolbar sx={{ justifyContent: 'center', position: 'relative' }}>
          <Button onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 10 }} startIcon={<FontAwesomeIcon icon={faChevronLeft} color={palette.primary.main} />}>
            Back
          </Button>
          <Typography variant="h4" component="div" color="primary" sx={{ textAlign: 'center' }}>
            ABLE
          </Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ p: 2 }}>
        <Outlet />
      </Container>
    </>
  );
};
